import { AlertTriangle, KeyRound, Droplets, BellRing, Flame, SunMedium, Zap, ArrowUpDown, DoorOpen, Layers, Biohazard, Waves, Tag } from "lucide-react";

// Common building characteristics -> dedicated icon (lucide) + emoji (for Leaflet HTML popups) + colour.
const MAP = {
  "gevaarlijke stoffen": { Icon: AlertTriangle, emoji: "⚠️", color: "#dc2626" },
  "sleutelkluis": { Icon: KeyRound, emoji: "🔑", color: "#ca8a04" },
  "sprinklerinstallatie": { Icon: Droplets, emoji: "💧", color: "#0ea5e9" },
  "brandmeldinstallatie": { Icon: BellRing, emoji: "🔔", color: "#ea580c" },
  "droge blusleiding": { Icon: Waves, emoji: "🚰", color: "#0891b2" },
  "gasaansluiting": { Icon: Flame, emoji: "🔥", color: "#f97316" },
  "zonnepanelen": { Icon: SunMedium, emoji: "☀️", color: "#eab308" },
  "aggregaat": { Icon: Zap, emoji: "⚡", color: "#7c3aed" },
  "lift": { Icon: ArrowUpDown, emoji: "🛗", color: "#475569" },
  "nooduitgang achterzijde": { Icon: DoorOpen, emoji: "🚪", color: "#16a34a" },
  "kelder": { Icon: Layers, emoji: "🕳️", color: "#64748b" },
  "asbest": { Icon: Biohazard, emoji: "☣️", color: "#b91c1c" },
};

export function kenmerkMeta(name) {
  return MAP[(name || "").trim().toLowerCase()] || { Icon: Tag, emoji: "🏷️", color: "#2563eb" };
}
